import {Settings} from './settings';

export class SettingsProd extends Settings {
  BASE_URL = 'https://v4.alpha.vaillant-vn.com';
}
